<template>
    <div>
        <page-title heading="Detail Stok Obat" :breadcrumb="[
          {
            label: 'Manajamen Stok',
            link: '/stok',
          },
          {
            label: 'Tambah Stok Obat & BHP',
            active: true,
          },
        ]" class="layout gantung ninja-shadow" />

        <div id="tambahStokObat" class="container-fluid ">
            <div class="card card-box mb-3 ninja-shadow __zoom_display">
                <div class="card-body">
                    <b-row>
                        <b-col md="12">
                            <b-row>
                                <b-col md="6">
                                    <div class="d-flex align-items-center" style="width: 100%;">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Nama Obat</label>
                                        </div>
                                        <div style="width: 72%">
                                            <vue-select-clearable id="medicineOpt" style="font-size: 13px"
                                                :options="medicineOpt" v-model="layanan.layanan_id" disabled
                                                placeholder="Pilih Obat">
                                            </vue-select-clearable>
                                        </div>
                                    </div>
                                    <div class="d-flex align-items-center mt-4" style="width: 100%;">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Stok</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-input :type="'text'" v-model="layanan.stock" :readonly="true">
                                            </b-input>
                                        </div>
                                    </div>
                                    <div class="align-items-center mt-4" style="width: 100%;" :class="{'d-none': !isAddStock, 'd-flex': isAddStock}">
                                        <div style="width: 28%">
                                            <label class="mb-md-0 required">Obat Masuk</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-input :type="'number'" min="0" v-model="layanan.stock_in"
                                                :class="{'is-invalid' : layanan.errorStockIn}"
                                                v-on:keydown.188.capture.prevent.stop
                                                v-on:keydown.190.capture.prevent.stop
                                                @keyup="checkStockValue($event.target.value)"
                                                @click="checkStockValue($event.target.value)"
                                                :readonly="isAddStock ? false : true">
                                            </b-input>
                                            <div class="text-danger" :class="{'d-none' : !layanan.errorStockIn}">
                                                {{layanan.errorStockInMsg}}
                                            </div>
                                        </div>
                                    </div>
                                </b-col>
                                <b-col md="6">
                                    <div class="align-items-center" style="width: 100%;" :class="{'d-none': !isAddStock, 'd-flex': isAddStock}">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Total Stok</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-input :type="'text'" v-model="layanan.total_stock" :readonly="true">
                                            </b-input>
                                        </div>
                                    </div>
                                    <div class="align-items-center d-flex" style="width: 100%;" :class="{'mt-4' : isAddStock}">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Satuan</label>
                                        </div>
                                        <div style="width: 72%">
                                            <vue-select-clearable id="satuanOpt" style="font-size: 13px"
                                                :options="satuanOpt" v-model="layanan.satuan_id" placeholder="Pilih Satuan" disabled>
                                            </vue-select-clearable>
                                        </div>
                                    </div>
                                    <div class="d-flex mt-4" style="width: 100%;">
                                        <div style="width: 28%">
                                            <label class="mb-md-0">Catatan</label>
                                        </div>
                                        <div style="width: 72%">
                                            <b-form-textarea id="textarea" v-model="layanan.note"
                                                :readonly="isAddStock ? false : true" placeholder="Input catatan pendukung...."
                                                rows="3" max-rows="6">
                                            </b-form-textarea>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </div>
            </div>
            <b-row>
                <b-col md="12" class="text-right">
                    <b-button variant="danger" class="mr-3" @click="cancelEdit()">
                        Keluar
                    </b-button>
                    <b-button variant="primary" @click="isAddStock ? saveStock() : addStock()"
                        :disabled="isAddStock ? (layanan.errorRow ? true : false) : false">
                        {{ isAddStock ? 'Simpan' : 'Tambah Stok' }}
                    </b-button>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
    components: {
        "vue-select-clearable": () => import("@/components/VueSelectClearable.vue")
    },
    data() {
        return {
            medicineOpt: [],
            satuanOpt: [],
            layananId: this.$route.params.id,
            layanan: {
                layanan_id: '',
                satuan_id: '',
                kode: '',
                nama: '',
                stock: '',
                stock_in: 0,
                total_stock: 0,
                note: "",
                errorStockIn: false,
                errorStockInMsg: "",
                errorRow: true
            },
            isAddStock: false
        }
    },
    computed: {
        ...mapGetters(["getKlinikId"])
    },
    created() {
        // this.getDetailLayanan();
        this.getMedicineOption();
    },
    methods: {
        async getSatuanOpt() {
            let path = `${this.url_api}/klinik/satuan/list`;
            let response = await axios.get(path);

            this.satuanOpt = response.data.data;
        },
        async getMedicineOption() {
            let path = `${this.url_api}/klinik/obat/list?klinik_id=${this.getKlinikId}&type=obat`;
            let response = await axios.get(path);

            this.medicineOpt = response.data.data;
            await this.getDetailLayanan();
            await this.getSatuanOpt();
            let selectedObat = this.medicineOpt.find(item => item.value == this.layananId)
            let selectedSatuan = this.satuanOpt.find(item => item.value == this.layanan.satuan_id)
            this.layanan.layanan_id = selectedObat;
            this.layanan.satuan_id = selectedSatuan;
        },
        async getDetailLayanan() {
            let path = `${this.url_api}/klinik/stock/${this.layananId}`

            let response = await axios.get(path);
            this.layanan = { ...this.layanan, ...response.data.data };
            this.layanan.note = this.layanan.note || '-' 
            this.layanan.stock = this.layanan.stock || 0 
        },
        checkStockValue(value) {
            let val = /[-.,]/.test(value) || isNaN(value) || value == "" ? 0 : parseInt(value);
            this.layanan.stock_in = val;
            this.layanan.total_stock = val + this.layanan.stock;

            if (!val) {
                this.layanan.errorStockIn = true;
                this.layanan.errorRow = true;
                this.layanan.errorStockInMsg = "Obat masuk harus diisi";
            } else {
                this.layanan.errorStockIn = false;
                this.layanan.errorRow = false;
                this.layanan.errorStockInMsg = "";
            }
        },
        cancelEdit() {
            this.$swal({
                title: 'Keluar',
                html: this.isAddStock
                    ? `Apakah Anda yakin untuk keluar dari halaman ini ? <br/> Data yang telah ditulis tidak akan tersimpan.`
                    : `Apakah Anda yakin untuk kembali ke halaman stok ?`,
                type: "warning",
                showCancelButton: true,
                cancelButtonText: "Tidak",
                confirmButtonText: "Ya",
                width: "650px"
            }).then(async (res) => {
                if (res.value) {
                    this.$router.push({ name: 'klinik-stok-obat' })
                }
            });
        },
        addStock() {
            this.isAddStock = true;
        },
        saveStock() {
            let path = `${this.url_api}/klinik/stock`;
            let data = {
                layanan_id: this.layananId,
                stock: this.layanan.stock_in,
                note: this.layanan.note,
                satuan_id: this.layanan.satuan_id ? this.layanan.satuan_id.value : 0
            }

            axios.post(path, [data])
                .then((response) => {
                    this.$swal({
                        title: 'Berhasil',
                        html: 'Stok berhasil ditambahkan',
                        type: 'success'
                    })

                    this.$router.push({ name: 'klinik-stok-obat' })
                })
                .catch(error => {
                    this.$swal({
                        title: 'Gagal',
                        html: 'Stok gagal ditambahkan',
                        type: 'error'
                    })
                })
        }
    }
}
</script>
<style>
.is-invalid {
    border: 1px solid red;
    border-radius: 0.29rem;
}

.required:after {
    content: " *";
    color: red;
    padding-left: 5px;
}

#tambahStokObat .__zoom_display {
    zoom: 80%;
}
</style>
